import {Injectable, signal} from '@angular/core';
import {ProductCompositionsFile} from "../types/product-compositions-modal.types";

@Injectable({
  providedIn: 'root'
})
export class ProductCompositionFilesStateService {
  private _productCompositionFilesState = signal<Record<number, Array<ProductCompositionsFile>>>({});
  public productCompositionFilesState = this._productCompositionFilesState.asReadonly();

  public setProductCompositionFilesState(id: number, productCompositionsFile: Array<ProductCompositionsFile>): void {
    this._productCompositionFilesState.set({
      ...this._productCompositionFilesState(),
      [id]: productCompositionsFile
    });
  }

  public getProductCompositionFilesById(id: number): Array<ProductCompositionsFile> {
    return this.productCompositionFilesState()[id];
  }

  public deleteFileById(fileId: number, productCompositionId: number): void {
    this._productCompositionFilesState.update(state => {
      const currentFiles = state[productCompositionId] || [];
      const updatedFiles = currentFiles.filter(file => file.id !== fileId);

      return {
        ...state,
        [productCompositionId]: updatedFiles
      };
    });
  }

  public updateProductCompositionFilesState(productCompositionId: number, productCompositionsFile: ProductCompositionsFile): void {
    this._productCompositionFilesState.update(state => {
      const currentFiles = state[productCompositionId] || [];
      const updatedFiles = [...currentFiles, productCompositionsFile];

      return {
        ...state,
        [productCompositionId]: updatedFiles
      };
    });
  }

  public deleteProductCompositionFilesState(productCompositionId: number): void {
    this._productCompositionFilesState.update(state => {
      const newState = { ...state };
      delete newState[productCompositionId];
      return newState;
    });
  }
}
